export enum NotificationStatus {
    info = 'info',
    warning = 'warning',
    success = 'success',
    error = 'error',
}
